import type { DashboardSummary } from "@chat-yai/shared/admin-types";
import { request } from "@/api/client";

export const dashboardApi = {
  summary() {
    return request<DashboardSummary>("/admin/dashboard/summary");
  },
};
